import { render, staticRenderFns } from "./message-rating-star.vue?vue&type=template&id=481d75e6&scoped=true"
import script from "./message-rating-star.vue?vue&type=script&lang=ts"
export * from "./message-rating-star.vue?vue&type=script&lang=ts"
import style0 from "./message-rating-star.vue?vue&type=style&index=0&id=481d75e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d75e6",
  null
  
)

export default component.exports